// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import './assets/tailwind.css';
import router from './router';
import '@fortawesome/fontawesome-free/css/all.css';
import { createPinia } from 'pinia';

// Import the auth store
import { useAuthStore } from './stores/useAuthStore';

const app = createApp(App);

const pinia = createPinia();

app.use(router);
app.use(pinia);

// Initialize the auth store
const authStore = useAuthStore();
authStore.init();

app.mount('#app');
